import React from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var LoadingSpinner = function LoadingSpinner(props) {
  var color = props.color,
    size = props.size,
    text = props.text;
  return /*#__PURE__*/_jsx("div", {
    className: "flex flex-col items-center justify-center w-full h-full",
    children: /*#__PURE__*/_jsxs("div", {
      className: "".concat(color ? color : "text-primary") + "flex flex-col self-center flex justify-center items-center space-x-1 text-sm  w-full h-full",
      children: [text && /*#__PURE__*/_jsx("p", {
        className: "text-[black]",
        children: text
      }), /*#__PURE__*/_jsx("svg", {
        fill: "none",
        className: "".concat(color ? color : "text-primary") + " w-".concat(size || 24, " h-").concat(size || 24, " animate-spin"),
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z",
          fill: "currentColor",
          fillRule: "evenodd"
        })
      })]
    })
  });
};
export var ProjectGridLoadingUI = function ProjectGridLoadingUI(props) {
  return /*#__PURE__*/_jsx("div", {
    "class": " flex",
    children: /*#__PURE__*/_jsxs("div", {
      "class": "bg-white p-4 rounded-md",
      children: [/*#__PURE__*/_jsx("div", {
        "class": "w-64 h-44 bg-gray-200 animate-pulse"
      }), /*#__PURE__*/_jsxs("div", {
        "class": "mt-8 h-32 w-full space-y-3",
        children: [/*#__PURE__*/_jsx("div", {
          "class": "w-20 h-6 bg-gray-200 rounded-full animate-pulse"
        }), /*#__PURE__*/_jsx("div", {
          "class": "w-full h-4 bg-gray-200 rounded-full animate-pulse"
        }), /*#__PURE__*/_jsx("div", {
          "class": "w-full h-4 bg-gray-200 rounded-full animate-pulse"
        }), /*#__PURE__*/_jsx("div", {
          "class": "w-1/2 h-4 bg-gray-200 rounded-full animate-pulse"
        })]
      })]
    })
  });
};
export var DetailProjectLoadingUI = function DetailProjectLoadingUI(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "px-7  mb-10",
    children: /*#__PURE__*/_jsxs("div", {
      "class": "bg-white p-2 sm:p-4 sm:h-64 rounded-2xl shadow-lg flex flex-col sm:flex-row gap-5 select-none ",
      children: [/*#__PURE__*/_jsx("div", {
        "class": "h-52 sm:h-full sm:w-72 rounded-xl bg-gray-200 animate-pulse"
      }), /*#__PURE__*/_jsxs("div", {
        "class": "flex flex-col flex-1 gap-5 sm:p-2",
        children: [/*#__PURE__*/_jsxs("div", {
          "class": "flex flex-1 flex-col gap-3",
          children: [/*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-full animate-pulse h-14 rounded-2xl"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-full animate-pulse h-3 rounded-2xl"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-full animate-pulse h-3 rounded-2xl"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-full animate-pulse h-3 rounded-2xl"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-full animate-pulse h-3 rounded-2xl"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          "class": "mt-auto flex gap-3",
          children: [/*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-20 h-8 animate-pulse rounded-full"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-20 h-8 animate-pulse rounded-full"
          }), /*#__PURE__*/_jsx("div", {
            "class": "bg-gray-200 w-20 h-8 animate-pulse rounded-full ml-auto"
          })]
        })]
      })]
    })
  });
};
function ProjectMapLoadingUI(props) {
  var className = props.className;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      "class": className ? className : "w-full flex items-center flex-col animate-bounce mt-16",
      children: /*#__PURE__*/_jsxs("div", {
        "class": "flex bg-white shadow-md p-4 rounded-md",
        children: [/*#__PURE__*/_jsx("div", {
          "data-placeholder": true,
          "class": "mr-2 h-20 w-20  overflow-hidden relative bg-gray-200"
        }), /*#__PURE__*/_jsxs("div", {
          "class": "flex flex-col justify-between",
          children: [/*#__PURE__*/_jsx("div", {
            "data-placeholder": true,
            "class": "mb-2 h-5 w-40 overflow-hidden relative bg-gray-200"
          }), /*#__PURE__*/_jsx("div", {
            "data-placeholder": true,
            "class": "h-10 w-40 overflow-hidden relative bg-gray-200"
          })]
        })]
      })
    })
  });
}
export default ProjectMapLoadingUI;